(() => {
  const STORAGE_KEY_FIRST = 'hrd_first_touch';
  const STORAGE_KEY_LAST = 'hrd_last_touch';

  const getStored = (key) => {
    try {
      return window.localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  };

  const formatTouch = (touch) => {
    const parts = [touch.utm_source, touch.utm_medium, touch.utm_campaign].filter(Boolean);
    return parts.length ? parts.join(' / ') : touch.referrer || '';
  };

  const fillField = (field, value) => {
    if (!value) return;
    document.querySelectorAll(`input[name="contact[${field}]"]`).forEach((input) => {
      if (!input.value) input.value = value;
    });
  };

  ['first', 'last'].forEach((type) => {
    const raw = getStored(type === 'first' ? STORAGE_KEY_FIRST : STORAGE_KEY_LAST);
    if (!raw) return;

    let touch;
    try {
      touch = JSON.parse(raw);
    } catch (e) {
      return;
    }

    const label = type === 'first' ? '初回流入元' : '最終流入元';
    fillField(label, formatTouch(touch));

    if (type === 'last') {
      fillField('gclid', touch.gclid);
      fillField('fbclid', touch.fbclid);
    }
  });
})();
